export default __webpack_public_path__ + "bdacf6e491b4385f8d42f8f1503cb065.svg";